document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('.popup-open');
  const slider = document.querySelector('.slideshow');

  if (!popup || !slider) return;

  function checkOverlap() {
    const popupRect  = popup.getBoundingClientRect();
    const sliderRect = slider.getBoundingClientRect();

    const horizontallyOverlapping =
      popupRect.left < sliderRect.right && popupRect.right > sliderRect.left;
    const verticallyOverlapping =
      popupRect.top < sliderRect.bottom && popupRect.bottom > sliderRect.top;

    const isOver = horizontallyOverlapping && verticallyOverlapping;

    popup.classList.toggle('is-over-slider', isOver);
  }

  // Run once and on scroll/resize
  checkOverlap();
  window.addEventListener('scroll', checkOverlap, { passive: true });
  window.addEventListener('resize', checkOverlap);
});
